import AnimalsActionsBar from "./AnimalsActionsBar";
import { EnterprisesGreenBox } from "containers/BudgetHome/Animals/EnterprisesGreenBox";
import BlockList from "./BlockList";

export default function Animals({ farm, analysis }) {
    return (
        <>
            <AnimalsActionsBar farm={farm} analysis={analysis} />
            <EnterprisesGreenBox farm={farm} analysis={analysis} />
            <BlockList farm={farm} analysis={analysis} />
        </>
    )
}
